import Trophy from "../../assets/trophy.png";
import First from "../../assets/first.png";
import Second from "../../assets/second.png";
import Third from "../../assets/third.png";
import useLeaderboard from "./useLeaderboard";

const LeaderBoard = ({ open, data, onClose }) => {
  const {
    state,
    testResult,
    loader,
    allTestResult,
    showFirstLastDigits,
    viewHandler,
    viewSolutionHandler,
  } = useLeaderboard({
    data,
  });
  if (!open) {
    return null;
  }

  return (
    <>
      <div className="fixed inset-0 bg-black opacity-50 z-50"></div>

      <div className="fixed inset-0 flex items-center justify-center z-50">
        {loader ? (
          <div className="animate-pulse h-32 bg-red-300 rounded"></div>
        ) : (
          <div
            className="bg-green-50 rounded-lg p-10 px-5 shadow-lg flex gap-5 flex-col justify-center items-center"
            style={{ width: 600 }}
          >
            {!state.view ? (
              <>
                <h2 className="text-xl font-bold mb-4">Score Card</h2>
                <span className="text-orange-500 text-xl font-bold">
                  <img src={Trophy} alt="trophy" className="h-12" />
                </span>
                <span className="text-lg font-semibold text-teal-700">
                  Leaderboard
                </span>

                {testResult?.objectId ? (
                  <div className="flex w-full bg-white rounded-lg items-center justify-between p-4">
                    <div className="flex gap-2 items-center">
                      {state.rank === 1 ? (
                        <img src={First} alt="first" className="h-8" />
                      ) : state.rank === 2 ? (
                        <img src={Second} alt="first" className="h-8" />
                      ) : state.rank === 3 ? (
                        <img src={Third} alt="first" className="h-8" />
                      ) : (
                        <span className="text-gray-400 font-semibold">
                          {state.rank}
                        </span>
                      )}
                      <span className="font-semibold text-lg">You</span>
                    </div>
                    <div className="flex flex-col gap-1 items-center">
                      <span className="font-semibold text-gray-500">
                        {testResult?.Percentage}%
                      </span>
                      <button
                        className="text-green-600 font-semibold"
                        onClick={viewHandler}
                      >
                        View Result
                      </button>
                    </div>
                  </div>
                ) : null}
                {allTestResult?.length > 1 ? (
                  <div className=" flex w-full flex-col gap-1  h-52 overflow-auto scrollbar-w-2 scrollbar-track-bg scrollbar-thumb-bg">
                    {allTestResult?.map((x, i) => (
                      <>
                        {x?.objectId === testResult?.objectId ? null : (
                          <div
                            key={x?.objectId}
                            className="flex w-full bg-white rounded-lg items-center justify-between p-4"
                          >
                            <div className="flex gap-2 items-center">
                              {1 === i + 1 ? (
                                <img src={First} alt="first" className="h-6" />
                              ) : 2 === i + 1 ? (
                                <img src={Second} alt="first" className="h-6" />
                              ) : 3 === i + 1 ? (
                                <img src={Third} alt="first" className="h-6" />
                              ) : (
                                <span className="font-semibold text-gray-400">
                                  {i + 1}.
                                </span>
                              )}
                              <span className=" text-gray-400 text-md">
                                {x?.CustName}
                                <br />
                                {showFirstLastDigits(x?.MaskedPhone)}
                              </span>
                            </div>
                            <div className="flex flex-col gap-1 items-center">
                              <span className="font-semibold text-gray-500">
                                {x?.Percentage}%
                              </span>
                              <span className="text-xs text-gray-300">
                                Marks: {x?.ObtainedMarks}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    ))}
                  </div>
                ) : null}
              </>
            ) : (
              <>
                <h2 className="text-md font-semibold rounded-lg mb-4 p-5 bg-amber-100 text-amber-600 flex w-full">
                  {testResult?.TestTitle}
                </h2>
                <div className="grid w-full grid-cols-2">
                  <div className="p-5 py-7 flex flex-col gap-1 items-center bg-orange-200 text-orange-700 font-semibold">
                    <span>Your Grade</span>
                    <span>{testResult?.YourGrade}</span>
                  </div>
                  <div className="p-5 py-7 flex flex-col gap-1 items-center bg-green-100 text-green-600 font-semibold">
                    <span>Average Grade</span>
                    <span>{state?.averageGrade}</span>
                  </div>
                  <div className="p-5 py-7 flex flex-col gap-1 items-center bg-amber-100 text-amber-600 font-semibold">
                    <span>Your Marks</span>
                    <span>{testResult?.ObtainedMarks}</span>
                  </div>
                  <div className="p-5 py-7 flex flex-col gap-1 items-center bg-pink-200 text-pink-500 font-semibold">
                    <span>Percentage</span>
                    <span>{testResult?.Percentage}%</span>
                  </div>
                </div>
              </>
            )}
            {!allTestResult?.length ? (
              allTestResult?.length === 1 ? null : (
                <span className="p-10 font-semibold">no data found</span>
              )
            ) : null}
            <div className="flex justify-center gap-2">
              <button
                onClick={onClose}
                className="bg-red-400 hover:bg-red-500 text-white px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                style={{ boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}
              >
                Close
              </button>
              {state.view && (
                <button
                  className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                  style={{ boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}
                  onClick={viewSolutionHandler}
                >
                  View Solutions
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default LeaderBoard;
